export enum PreferenceElevationEnum {
    EMPTY = '',
    VERY_LOW = 'very-low-elevation',
    LOW = 'low-elevation',
    MEDIUM = 'medium-elevation',
    HIGH = 'high-elevation',
    VERY_HIGH = 'very-high-elevation',
    ULTRA = 'ultra-elevation',
}
